// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.chat-info-tag[data-v-4c5ba0cd] {\n  display: inline-block;\n}\n.chat-info-tag--link[data-v-4c5ba0cd]:hover {\n  opacity: 0.7;\n}\n.max-tag-width[data-v-4c5ba0cd] {\n  max-width: 300px; /* Adjust this value based on your design requirements */\n  max-width: 20vw; \n  overflow: hidden;\n  white-space: nowrap;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
